/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject, inject, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { dispatch, Store } from '@ngxs/store';
import { first, map, tap } from 'rxjs/operators';

import { SearchService } from '../services/search.service';
import { CancelChooseSearch, ChooseSearch } from '../state/search.actions';
import { SearchState } from '../state/search.state';
import { LoggerService } from '../../shared/services/logger.service';
import { SearchListEntry } from '../state/search.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-choose-search',
    templateUrl: './choose-search-dialog.component.html',
    styleUrls: ['./choose-search-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        LayoutDirective,
        LayoutAlignDirective,
        MatButton,
        MatDialogActions,
        AsyncPipe,
    ],
})
export class ChooseSearchDialogComponent implements OnInit {
    searches$: Observable<SearchListEntry[]> = inject(Store).select(SearchState.searches);

    constructor(
        private logger: LoggerService,
        private matDialogRef: MatDialogRef<ChooseSearchDialogComponent>,
        private searchService: SearchService,
        private store: Store,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) {}

    ngOnInit() {}

    public choose(searchName: string) {
        this.searches$
            .pipe(
                first(),
                map((searches) => searches.find((s) => s.name === searchName)),
                tap((searchDef: SearchListEntry) =>
                    this.store.dispatch(
                        new ChooseSearch({
                            id: this.data.id,
                            search: searchDef,
                            reset: this.data.reset,
                        })
                    )
                )
            )
            .subscribe(() => this.matDialogRef.close(true));
    }

    public cancel() {
        this.store.dispatch(new CancelChooseSearch()).subscribe(() => this.matDialogRef.close(false));
    }
}
